import PropTypes from 'prop-types';
import { twJoin } from 'tailwind-merge';

import Icon from 'shopper/components/Icon';
import Tag from 'shopper/components/Tag/V2';
import Text from 'shopper/components/Text';

import placeholder from 'lib/placeholder';

import COUPONS from 'constants/coupons';

const getCouponCodeText = (couponCode, visibility) => {
  if (visibility === COUPONS.VISIBILITY_STATUS.APP_ONLY) {
    return COUPONS.BADGES.APP_ONLY;
  }

  return couponCode || COUPONS.COUPON_WITH_NO_CODE;
};

const CouponListItem = ({
  className,
  couponCode,
  couponTitle,
  visibility,
  onOpenCouponPicker,
}) => (
  <button
    className={twJoin(
      'grid w-full gap-y-4 border py-4 transition-all hover:opacity-60 lg:grid-cols-8',
      className
    )}
    onClick={onOpenCouponPicker}
  >
    <Tag className="col-start-1 row-start-2 lg:row-start-1" size="size2">
      {placeholder('descriptions.expiredCoupon')}
    </Tag>
    <Text
      as="h2"
      className="col-span-4 self-center text-pretty text-start text-neutral-high-500 lg:col-span-6 lg:col-start-2"
      size="size2"
    >
      {couponTitle}
    </Text>
    <div className="col-start-4 row-start-2 flex w-max items-center gap-x-2 self-center justify-self-end lg:col-start-8 lg:row-start-1">
      <Icon
        className="text-neutral-low-400"
        name="ticket-simple"
        size="size2"
      />
      <Text className="text-neutral-low-400 line-through" size="size2" bold>
        {getCouponCodeText(couponCode, visibility)}
      </Text>
    </div>
  </button>
);

CouponListItem.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  couponCode: PropTypes.string,
  couponTitle: PropTypes.string.isRequired,
  visibility: PropTypes.string.isRequired,
  onOpenCouponPicker: PropTypes.func.isRequired,
};

export default CouponListItem;
